$(function () {


});

//Добавление класса следующему элементу
const btn = document.getElementById('whats-this');
const next = btn.nextElementSibling;

btn.addEventListener('click', function (event) {
    event.stopPropagation(); // блокируем всплытие до документа
    next.classList.toggle('open');
    //btn.classList.toggle('hidden');
});

document.addEventListener('click', function (event) {
    // Если клик не по кнопке и не внутри следующего элемента → убираем класс
    if (!btn.contains(event.target) && !next.contains(event.target)) {
        next.classList.remove('open');
        //btn.classList.remove('hidden');
    }
});

//кнопка прокрутки вверх
const scrollTopBtn = document.getElementById("scrollTopBtn");

window.addEventListener("scroll", () => {
if (window.scrollY > 300) {
    scrollTopBtn.classList.add("show");
} else {
    scrollTopBtn.classList.remove("show");
}
});

scrollTopBtn.addEventListener("click", () => {
window.scrollTo({
    top: 0,
    behavior: "smooth"
});
});